"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCancelledCancellation(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.994 1c1.572.177 4.521 2.648 4.521 2.648 1.256.964 2.746 1.516 4.468 1.658.273 7.068-2.69 12.475-8.892 17.264 0 0-.109.049-.182 0-6.201-4.789-9.165-10.196-8.892-17.264 1.64-.135 3.07-.642 4.287-1.523 0 0 3.046-2.597 4.7-2.783h-.01z",
    fill: "url(#cancelled-cancellation_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 8.875l-6.25 6.25m6.25 0l-6.25-6.25",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancelled-cancellation_svg__a",
    x1: 3,
    y1: 1,
    x2: 24.841,
    y2: 17.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FA4668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E067AE"
  }))));
}

var MemoSvgCancelledCancellation = /*#__PURE__*/React.memo(SvgCancelledCancellation);
var _default = MemoSvgCancelledCancellation;
exports["default"] = _default;